import JobItem from "./JobItem";

export default JobItem;
